module.exports = __webpack_public_path__ + "static/mitsui-4a2aa16f6f57f7abff70ddae22f1935c.mp4";